import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Date input with calendar addon button.
 * Uses native <input type="date"> with min/max for picker restriction.
 * Clicking the calendar icon opens the picker.
 */
import { useRef } from 'react';
import { InputAddon } from './InputAddon';
function todayLocal() {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}
export function DateField({ id, value, onChange, required, className }) {
    const inputRef = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsx("input", { ref: inputRef, id: id, type: "date", className: `form-control ${className || ''}`, value: value, onChange: (e) => onChange(e.target.value), min: "2000-01-01", max: todayLocal(), required: required }), _jsx(InputAddon, { icon: "calendar", onClick: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.showPicker(); } })] }));
}
